<template>
    <div ref="loginModal" style="visibility: hidden;position: absolute; left: -999em;">
        <div class="form-group has-feedback has-feedback-left">
            <input type="text" class="form-control" placeholder="Username" id="username">
            <div class="form-control-feedback">
                <i class="fa fa-user text-muted"></i>
            </div>
        </div>

        <div class="form-group has-feedback has-feedback-left">
            <input type="password" class="form-control" placeholder="Password" id="password">
            <div class="form-control-feedback">
                <i class="fa fa-lock text-muted"></i>
            </div>
        </div>

        <div class="text-center">
            <a href="#" @click.prevent="forgotPassword">Forgot password?</a>
        </div>
    </div>
</template>
<script>
    import firebase from 'firebase'
    import swal from 'sweetalert2'

    export default {
        name: 'login-modal',
        props: ['showModal', 'toggleModal'],
        data () {
            return {
                username: ''
            }
        },
        watch: {
            showModal: function(newVal, oldVal) {
                if (newVal) this.openLogin();
            }
        },
        methods: {
            openLogin () {
                let vm = this;
                swal({
                    title: 'Login',
                    html: this.$refs.loginModal.innerHTML
                        .replace('id="username"', 'id="modalUsername"')
                        .replace('id="password"', 'id="modalPassword"'),
                    showCancelButton: true,
                    confirmButtonText: 'Login',
                    cancelButtonText: 'Cancel'
                }).then(function() {
                    firebase.auth().signInWithEmailAndPassword(document.getElementById('modalUsername').value,
                        document.getElementById('modalPassword').value).then(function(user) {
                        swal(
                            'Success!',
                            'Thanks for logging in!',
                            'success');
                        vm.toggleModal();
                    }, function(error) {
                        //var errorCode = error.code;
                        var errorMessage = error.message;
                        swal(
                            'Error!',
                            errorMessage,
                            'error');
                        vm.toggleModal();
                    });
                })
            },
            forgotPassword () {
                swal(
                    'Soon',
                    'Not implemented yet',
                    'info');
            }
        },
    }
</script>


// WEBPACK FOOTER //
// LoginModal.vue?bf82d766